var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.5429 3.42857L10.9029 15.7457H13.68L14.0657 3.42857H10.5429ZM10.8514 21.0429C11.2457 21.42 11.7514 21.6086 12.3686 21.6086C12.9514 21.6086 13.4314 21.42 13.8086 21.0429C14.2029 20.6657 14.4 20.2114 14.4 19.68C14.4 19.1314 14.2029 18.6686 13.8086 18.2914C13.4314 17.9143 12.9514 17.7257 12.3686 17.7257C11.7514 17.7257 11.2457 17.9143 10.8514 18.2914C10.4743 18.6686 10.2857 19.1314 10.2857 19.68C10.2857 20.2114 10.4743 20.6657 10.8514 21.0429Z",
    fill: "#FF7A00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.d813c922f8ebe73b46293348ee94bfd6.svg";
export { ForwardRef as ReactComponent };